import React from "react"
import Grid from "@material-ui/core/Grid"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { makeStyles, useTheme } from "@material-ui/styles"

const useStyles = makeStyles(theme => {
  return {
    containerWrapper: props => ({
      flexDirection: "inherit",
      flexWrap: props.wrapReverse ? "wrap-reverse" : "wrap",
      maxWidth:
        !props.noMaxWidth &&
        theme.breakpoints.values.xl -
          theme.spacing(theme.breakpoints.margins.xl * 2),
      overflow: "hidden",
      position: "relative",
      [theme.breakpoints.up("sm")]: {
        marginLeft:
          !props.noMargins && theme.spacing(theme.breakpoints.margins.sm),
        marginRight:
          !props.noMargins && theme.spacing(theme.breakpoints.margins.sm),
      },
      [theme.breakpoints.up("md")]: {
        marginLeft:
          !props.noMargins && theme.spacing(theme.breakpoints.margins.md),
        marginRight:
          !props.noMargins && theme.spacing(theme.breakpoints.margins.md),
      },
      [theme.breakpoints.up("lg")]: {
        marginLeft:
          !props.noMargins && theme.spacing(theme.breakpoints.margins.lg),
        marginRight:
          !props.noMargins && theme.spacing(theme.breakpoints.margins.lg),
      },
      [theme.breakpoints.up("xl")]: {
        marginLeft:
          !props.noMargins &&
          (props.noMaxWidth
            ? theme.spacing(theme.breakpoints.margins.xl)
            : "auto"),
        marginRight:
          !props.noMargins &&
          (props.noMaxWidth
            ? theme.spacing(theme.breakpoints.margins.xl)
            : "auto"),
      },
    }),
    container: props => ({
      flexWrap: "inherit",
      flexDirection: "inherit",
      height: "100%",
      justifyContent: props.centered && "center",
    }),
    divider: {
      marginLeft: theme.spacing(3),
      borderTop: "0.5px solid #C3C5C8",
    },
  }
})

export default props => {
  const classes = useStyles(props)
  const theme = useTheme()
  const aboveSm = useMediaQuery(theme.breakpoints.up("sm"))
  const aboveMd = useMediaQuery(theme.breakpoints.up("md"))
  const aboveLg = useMediaQuery(theme.breakpoints.up("lg"))
  const aboveXl = useMediaQuery(theme.breakpoints.up("xl"))

  var { xs, sm, md, lg, xl, ...otherProps } = props
  sm = sm || xs
  md = md || sm
  lg = lg || md
  xl = xl || lg

  if (props.item) {
    xs = xs ? (xs * 3 > 12 ? 12 : xs * 3) : undefined
    sm = sm ? (sm * 3 > 12 ? 12 : sm * 3) : xs
    md = md ? ((md * 3) / 2 > 12 ? 12 : Math.floor((md * 3) / 2)) : undefined

    const newProps = {
      xs: xs,
      sm: sm,
      md: md,
      lg: lg,
      xl: xl,
      ...otherProps,
    }

    return <Grid {...newProps} />
  } else if (props.container) {
    xl = xl === undefined ? theme.breakpoints.gutters.xl : xl
    lg = lg === undefined ? theme.breakpoints.gutters.lg : lg
    md = md === undefined ? theme.breakpoints.gutters.md : md
    sm = sm === undefined ? theme.breakpoints.gutters.sm : sm
    xs = xs === undefined ? theme.breakpoints.gutters.xs : xs

    const spacing = aboveXl
      ? xl
      : aboveLg
      ? lg
      : aboveMd
      ? md
      : aboveSm
      ? sm
      : xs

    const {
      className,
      noMaxWidth,
      noMargins,
      centered,
      headerSpacing,
      wrapReverse,
      ...newProps
    } = otherProps

    return (
      <div className={[classes.containerWrapper, className].join(" ")}>
        <Grid
          spacing={spacing}
          classes={{ container: classes.container }}
          {...newProps}
        />
      </div>
    )
  }
}
